import styles from "./Input.module.css"

export default function Input(props){
  let classes = styles.input;

  if (props.options.length > 0)
    classes += " " + styles.active

  return (<div className={classes}>

    {props.options.map(function(item, i){
      return(<div className={styles.option} onClick={() => props.addMessage(item.opcion, item.destino)}>
            <p dangerouslySetInnerHTML={{__html: item.opcion.toString()}}></p>
          </div>)
    })}

  </div>);
}
